<span class="cursor-pointer" (click)="copy()">
  <ng-container *ngIf="!($copying | async)">Copy {{label}}</ng-container>
  <ng-container *ngIf="($copying | async)">Copied to clipboard</ng-container>
</span>
